var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('div',{class:_vm.b('table-column')},[_c('cards-table',{attrs:{"cards":_vm.cards,"total":_vm.total}})],1),_c('div',{class:_vm.b('chart-container')},[_c('cards-chart',{attrs:{"cards":_vm.cards,"total":_vm.total}})],1)]),_c('cards-debt-chart',{attrs:{"cards":_vm.cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }